import { render, staticRenderFns } from "./LandingPageNavbar.vue?vue&type=template&id=4edc059a&scoped=true"
import script from "./LandingPageNavbar.vue?vue&type=script&lang=js"
export * from "./LandingPageNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edc059a",
  null
  
)

export default component.exports